<template>
  <div class="defaultDiv"><empty></empty></div>
</template>
<script>
import empty from "../../components/tips/Empty";
export default {
  props: {},
  data() {
    return {};
  },
  watch: {},
  components: {
    empty
  },
  async mounted() {},
  methods: {},
  created() {}
};
</script>
<style lang="less" scoped>
.defaultDiv {
  top: 50%;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
